<script lang="ts" context="module">
  import { getAppConfig } from '../../../../common/config/app-config';
  import { CONSTANTS } from '../../../../common/config/constants';
  import { getIsPrimeNoPlan, getServiceJoodCardType } from '../../../../common/joodUtils';
  import {
    getContextedUrl,
    getJoodExpiredMembershipType,
    getJoodMembershipType,
    getStr,
    globalCurrencyTag,
  } from '../../../../common/util';
  import JoodExpire from '../../../common/components/productTile/components/JoodExpire.svelte';
  import ProductTileJoodWalletCreditAmount from '../../../common/components/productTile/components/ProductTileJoodWalletCreditAmount.svelte';
  import { getServiceBlockForCode, getServiceProductCodes, jsVasDetailsClickHandler } from './atc-utils';

  const {
    extraThemeResourcePath,
    primeEnabled,
    lang,
    currency,
    joodExpiredFlag,
    benefitType = 'DISCOUNT',
    joodFullCappingLimitReached,
  } = getAppConfig();
  const membershipType = getJoodMembershipType();
  const expiredMembershipType = getJoodExpiredMembershipType();
  const addonLabel = getStr('extra.pdp.service.addon');
  const addonName = getStr('extra.pdp.service.accidental.warranty.text');
  const imageBaseUrl = `${extraThemeResourcePath}/images`;
  const extra_service_store_device = `${imageBaseUrl}/extra_service_store_device.svg`;
  const extra_service_unpack_device = `${imageBaseUrl}/extra_service_unpack_device.svg`;
  const { VIP, BASIC, SMART, NOPRIME, VIPPRIME, BASICPRIME, SMARTPRIME } = CONSTANTS;
</script>

<script lang="ts">
  import AtcFormatPrice from './AtcFormatPrice.svelte';
  import AtcJoodVasPrimeDetails from './AtcJoodVasPrimeDetails.svelte';
  import AtcJoodVasService from './AtcJoodVasService.svelte';

  export let entry;
  export let selectedServices;
  export let product;
  export let parentEntryNumber;
  export let loopindex;

  let _servicePrimeCount = 0;
  let servicesBlockContent = '';
  let servicesBlockImage = '';
  let servicesBlockLabel = '';
  let servicesBlockLink = '';
  let noPlanVasOptionSelected = false;
  let selectedCombinedServiceGroupNumber = null;
  let selectedCombinedEntrynumber = null;
  let selectedCombinedAddOnEntrynumber = null;
  let selectedCombinedAddOnServiceGroupNumber = null;
  const isPrimeNoPlan = getIsPrimeNoPlan(membershipType, entry?.vasPrices);
  const joodCapLimitReached = joodFullCappingLimitReached === 'true';

  $: esstentialclass = computEesstentialclass(entry);
  $: if (product?.servicesBlocks?.length > 0) {
    ({ servicesBlockContent, servicesBlockImage, servicesBlockLabel, servicesBlockLink } = getServiceBlockForCode(
      product.servicesBlocks,
      'servicesSafeguardPDPContent'
    ));
  }

  function computEesstentialclass(entry) {
    if (!entry.combinedVas || entry.vasPrices.length < 5) {
      return '';
    }
    if (entry.vasPrices.length > 6) {
      return 'c-essential-plus more-estentail-plus';
    }
    return 'c-essential-plus';
  }
  function getCombinedVasDetails(selectedServices, vasPrice) {
    if (selectedServices?.length > 0) {
      const combinedVasOptionSelected = selectedServices?.find(
        selectedService =>
          selectedService.vasType === vasPrice.vasType.code && selectedService.priceType === vasPrice.priceType
      )
        ? 'selected'
        : '';
      noPlanVasOptionSelected = !!selectedServices?.find(
        selectedService => selectedService.vasType === 'noPlan' && selectedService.priceType === 'NO_PLAN_PRICE'
      );
      const temp = selectedServices.find(selectedService => entry.vasGroup === selectedService.vasGroup);
      if (temp) {
        selectedCombinedServiceGroupNumber = temp.serviceGroupNumber || null;
        selectedCombinedEntrynumber = temp.entryNumber;
      }
      return {
        combinedVasOptionSelected,
        noPlanVasOptionSelected,
      };
    }

    return {
      combinedVasOptionSelected: '',
      noPlanVasOptionSelected: false,
    };
  }
  function incrementServicePrimeCount() {
    _servicePrimeCount += 1;
    return '';
  }

  function getVasPriceDetails(selectedServices, vasPrice) {
    let combinedVasOptionSelected = null,
      combinedVasAddonSelected = null,
      selectedServiceVasType = null;

    if (selectedServices?.length > 0) {
      const selectedService = selectedServices.find(
        ss => ss.vasType === vasPrice.vasType.code && ss.priceType === vasPrice.priceType
      );
      if (selectedService) {
        combinedVasOptionSelected = 'selected';
        selectedServiceVasType = selectedService.vasType;

        if (selectedService.combinedVas && vasPrice.additionalAwsProductCode?.length > 0) {
          combinedVasAddonSelected = 'selected';
        }

        if (entry.vasGroup === selectedService.vasGroup) {
          selectedCombinedAddOnEntrynumber = selectedService.entryNumber;
          selectedCombinedAddOnServiceGroupNumber = selectedService.serviceGroupNumber;
        }
      }
    }

    const output = {
      combinedVasOptionSelected,
      combinedVasAddonSelected,
      selectedServiceVasType,
    };

    return output;
  }

  function getVasDetails(selectedServices, vasPrice) {
    let vasOptionSelected = null,
      selectedEntrynumber = null;

    if (selectedServices?.length > 0) {
      noPlanVasOptionSelected = !!selectedServices.find(
        selectedService => selectedService.vasType === 'noPlan' && selectedService.priceType === 'NO_PLAN_PRICE'
      );
      vasOptionSelected = selectedServices.find(
        selectedService =>
          selectedService.vasType === vasPrice.vasType.code && selectedService.priceType === vasPrice.priceType
      )
        ? 'selected'
        : '';
      const t = selectedServices.find(selectedService => entry.vasGroup === selectedService.vasGroup);
      if (t) {
        selectedEntrynumber = t.entryNumber;
      }
    }

    return {
      vasOptionSelected,
      noPlanVasOptionSelected,
      selectedEntrynumber,
    };
  }
</script>

<div class="row-flex">
  <div class="col-flex-xs-12 col-flex-md-12">
    <img alt="Extrasafeguard" src={servicesBlockImage} />
  </div>
  <div class="col-flex-xs-12 col-flex-md-12 c_extra-service-label">
    {servicesBlockLabel}
  </div>
  <div class="col-flex-xs-12 col-flex-md-12 c_extra-vas-content">
    <span class="">
      {@html servicesBlockContent}
    </span>
  </div>
  <div class="col-flex-xs-12 col-flex-md-12 c_extra-vas-link">
    <a href={servicesBlockLink} target="_blank" rel="nofollow noopener noreferrer">
      {getStr('extra.vas.service.learn.more')}
    </a>
  </div>

  {#if entry.combinedVas}
    <div
      style="flex-wrap: nowrap;"
      class="{membershipType} col-flex-xs-12 col-flex-md-12 vas-details-wrapper c_vas-details-items js-extraSetup-button-active-remove c-vas-safecaurd"
    >
      {#each entry.vasPrices as vasPrice, vasPriceIndex}
        {@const { combinedVasOptionSelected } = getCombinedVasDetails(selectedServices, vasPrice)}
        {@const serviceProductCodes = getServiceProductCodes(vasPrice, entry)}
        {@const serviceJoodCardType = getServiceJoodCardType(
          membershipType,
          expiredMembershipType,
          vasPrice,
          isPrimeNoPlan
        )}
        {#if vasPrice.additionalAwsProductCode === null && vasPrice.additionalAwsVasGroup === null}
          <button
            class="{membershipType} c_vas-details-list add-to-cart-service data-index-{vasPriceIndex} {esstentialclass} {vasPriceIndex} js-vas-details-svelte {benefitType ===
            'WALLET'
              ? `service-${serviceJoodCardType}`
              : ''}"
            on:click={jsVasDetailsClickHandler}
            class:no-plan={vasPrice.noPlanOption}
            class:selected={vasPrice.defaultWarranty || combinedVasOptionSelected?.length > 0}
            data-item-add={combinedVasOptionSelected === 'selected' ? 'true' : 'false'}
            data-type={servicesBlockLabel}
            data-service="safeguard"
            data-additional-aws-productCode={vasPrice.additionalAwsProductCode}
            data-source="Cart Popup"
            data-plan={vasPrice.vasType.labelEn}
            data-serviceid={vasPriceIndex + 1}
            data-addon="no addon"
            data-noplanenabled={entry.noPlanIncluded}
            data-price="{vasPrice?.servicePrice?.formattedValue} {currency}"
            data-vasType={vasPrice.vasType.code}
            data-productcode={product.code}
            data-id={vasPriceIndex}
            data-entryNumber="extra-vas-{parentEntryNumber}"
          >
            <div class="col-md-12">
              {#if primeEnabled}
                <div class="c_vas-details-jood-container">
                  {#if membershipType !== NOPRIME}
                    {#if membershipType === BASICPRIME && vasPrice?.vipPrimeDiscountPrice?.value > 0}
                      {incrementServicePrimeCount()}
                    {/if}
                    {#if membershipType === VIPPRIME && vasPrice?.vipPrimeDiscountPrice?.value > 0}
                      <AtcJoodVasPrimeDetails
                        joodType={VIP}
                        vasLabel={vasPrice?.vasType.label}
                        oldVasPrice={vasPrice?.servicePrice?.formattedValue}
                        vasPrice={vasPrice?.vipPrimeDiscountPrice?.formattedValue}
                        isNoPlan={vasPrice?.noPlanOption}
                      />
                      {#if benefitType === 'WALLET' && !joodCapLimitReached}
                        <ProductTileJoodWalletCreditAmount
                          creditPoints={vasPrice?.vipPrimeDiscountPrice?.formattedValue}
                          variant="pdp-services"
                          priceType={VIPPRIME}
                          isTacticalFlag={false}
                        />
                      {/if}
                    {:else if membershipType === BASICPRIME && vasPrice?.basicPrimeDiscountPrice?.value > 0}
                      <AtcJoodVasPrimeDetails
                        joodType={BASIC}
                        vasLabel={vasPrice?.vasType.label}
                        oldVasPrice={vasPrice?.servicePrice?.formattedValue}
                        vasPrice={vasPrice?.basicPrimeDiscountPrice?.formattedValue}
                        isNoPlan={vasPrice?.noPlanOption}
                      />
                      {#if benefitType === 'WALLET' && !joodCapLimitReached}
                        <ProductTileJoodWalletCreditAmount
                          creditPoints={vasPrice?.basicPrimeDiscountPrice?.formattedValue}
                          variant="pdp-services"
                          priceType={BASICPRIME}
                          isTacticalFlag={false}
                        />
                      {/if}
                    {:else}
                      <AtcJoodVasPrimeDetails
                        joodType={BASIC}
                        vasLabel={vasPrice?.vasType.label}
                        oldVasPrice={vasPrice?.servicePrice?.formattedValue}
                        vasPrice={vasPrice?.discountedPrice?.formattedValue}
                        isNoPlan={vasPrice?.noPlanOption}
                      />
                    {/if}
                  {:else if membershipType === NOPRIME || expiredMembershipType === BASICPRIME || expiredMembershipType === VIPPRIME}
                    {#if vasPrice?.vipPrimeDiscountPrice?.value > 0}
                      {incrementServicePrimeCount()}
                    {/if}
                    <section>
                      <div class="c_vas-details-list-year c-vas-safecaurd">
                        {#if vasPrice.percentageDiscount !== null && vasPrice.percentageDiscount.value > 0 && vasPrice.percentageDiscount.value < 100}
                          <span class="c_product-details-title-reduction">
                            {#if lang === 'en'}
                              {vasPrice.percentageDiscount.value}%&nbsp;<span
                                >{getStr('product.pourcentageDiscount.off')}</span
                              >
                            {:else}
                              %{vasPrice.percentageDiscount.value}&nbsp;<span
                                >{getStr('product.pourcentageDiscount.off')}</span
                              >
                            {/if}
                          </span>
                        {/if}
                        {vasPrice.vasType.label}
                      </div>
                      <div class="vas-name" class:hide={vasPrice.noPlanOption}>
                        <span>{vasPrice.vasType.name}</span>
                      </div>
                    </section>
                    {#if vasPrice.discountedPrice !== null}
                      <div class="c_product-price-prices" class:hide={vasPrice.noPlanOption}>
                        <div class="c_product-price-was-is">
                          <span class="c_product-price-previous">{vasPrice.servicePrice.value} </span>
                        </div>
                        <div class="c_product-price-current">
                          <AtcFormatPrice
                            priceData={vasPrice.discountedPrice}
                            displayFreeForZero={true}
                            addCurrency={true}
                          />
                        </div>
                      </div>
                    {:else}
                      <div class="c_vas-details-list-price" class:hide={vasPrice.noPlanOption}>
                        <AtcFormatPrice
                          priceData={vasPrice.servicePrice}
                          displayFreeForZero={true}
                          addCurrency={true}
                        />
                      </div>
                    {/if}

                    {#if benefitType === 'WALLET' && !joodCapLimitReached}
                      {#if expiredMembershipType === BASICPRIME && vasPrice?.basicPrimeDiscountPrice?.value > 0}
                        <ProductTileJoodWalletCreditAmount
                          creditPoints={vasPrice?.basicPrimeDiscountPrice?.formattedValue}
                          variant="pdp-services"
                          priceType={BASICPRIME}
                          isTacticalFlag={false}
                        />
                      {:else if vasPrice?.vipPrimeDiscountPrice?.value > 0 && membershipType !== NOPRIME}
                        <ProductTileJoodWalletCreditAmount
                          creditPoints={vasPrice?.vipPrimeDiscountPrice?.formattedValue}
                          variant="pdp-services"
                          priceType={VIPPRIME}
                          isTacticalFlag={false}
                        />
                      {/if}
                    {/if}
                  {/if}
                </div>
              {:else}
                <section>
                  <div class="c_vas-details-list-year c-vas-safecaurd">
                    {#if vasPrice.percentageDiscount !== null && vasPrice.percentageDiscount.value > 0 && vasPrice.percentageDiscount.value < 100}
                      <span class="c_product-details-title-reduction">
                        {#if lang === 'en'}
                          {vasPrice.percentageDiscount.value}%&nbsp;<span
                            >{getStr('product.pourcentageDiscount.off')}</span
                          >
                        {:else}
                          %{vasPrice.percentageDiscount.value}&nbsp;<span
                            >{getStr('product.pourcentageDiscount.off')}</span
                          >
                        {/if}
                      </span>
                    {/if}
                    {vasPrice.vasType.label}
                  </div>
                  <div class="vas-name" class:hide={vasPrice.noPlanOption}>
                    <span>{vasPrice.vasType.name}</span>
                  </div>
                </section>
                {#if vasPrice.discountedPrice !== null}
                  <div class="c_product-price-prices" class:hide={vasPrice.noPlanOption}>
                    <div class="c_product-price-was-is">
                      <span class="c_product-price-previous">{vasPrice.servicePrice.value} </span>
                    </div>
                    <div class="c_product-price-current">
                      <AtcFormatPrice
                        priceData={vasPrice.discountedPrice}
                        displayFreeForZero={true}
                        addCurrency={true}
                      />
                    </div>
                  </div>
                {:else}
                  <div class="c_vas-details-list-price" class:hide={vasPrice.noPlanOption}>
                    <AtcFormatPrice priceData={vasPrice.servicePrice} displayFreeForZero={true} addCurrency={true} />
                  </div>
                {/if}
              {/if}

              {#each serviceProductCodes as code}
                {@const freeGiftData = vasPrice.serviceFreeGiftMap[code] || null}
                {#if !!freeGiftData}
                  {@const sourceQty = freeGiftData.freeGiftQtuantities['sourceQty']}
                  {@const targetQty = freeGiftData.freeGiftQtuantities['targetQty']}
                  <div
                    class="c_gift-items js-freegiftexist"
                    class:js-freegiff-set-fixed={sourceQty === targetQty}
                    class:c_gift-items-fixed={sourceQty === targetQty}
                  >
                    <div class="c_gift-items-title">
                      {#if sourceQty < targetQty}
                        <span class="c_gift-items-title--color">
                          {getStr('product.promotion.freegifts.display.lower.txt', [sourceQty])}</span
                        >
                      {:else}
                        <span class="c_gift-items-title--color">
                          {getStr('text.fixed.freegift.count.display.txt.vas', [sourceQty])}
                        </span>&nbsp;{getStr('product.promotion.freegifts.item.worth.txt')}&nbsp;
                        <span class="c_gift-items-title--color mobile-font"
                          >{freeGiftData.freeGiftWorth}
                          {@html globalCurrencyTag}</span
                        >
                      {/if}
                    </div>
                  </div>
                {/if}
              {/each}
            </div>
            <div class="hide">
              <div class="c_vas-details-list-button">
                <form
                  id="vasAddToCartForm{product.code}{vasPriceIndex}-{loopindex}"
                  action={getContextedUrl('/cart/vas/add')}
                  method="post"
                  class="c_form js-formValidation js-vas-addtocart-form"
                  data-ajax="true"
                  data-submit="vasaddtocart"
                >
                  <div id="test_vasAddToCartButton_$" style="display:inline">
                    {#if vasPrice.noPlanOption}
                      <input type="hidden" name="vasProductCode" value={entry.noPlanProductCode} />
                      <input type="hidden" name="noPlanOption" value={vasPrice.noPlanOption} />
                    {:else}
                      <input
                        type="hidden"
                        name="vasProductCode"
                        value={vasPrice?.productCodes?.length > 0 ? vasPrice.productCodes : entry.serviceProductCode}
                      />
                    {/if}
                    <input type="hidden" name="vasType" value={vasPrice.vasType.code} />
                    <input type="hidden" name="priceType" value={vasPrice.priceType} />
                    <input type="hidden" name="priceTo" value={vasPrice.priceTo} />
                    <input type="hidden" name="productCode" value={product.code} />
                    <input type="hidden" name="additionalAwsProductCode" value={vasPrice.additionalAwsProductCode} />
                    <input type="hidden" name="additionalAwsVasGroup" value={vasPrice.additionalAwsVasGroup} />
                    <input type="hidden" name="combinedVas" value={entry.combinedVas} />
                    <input type="hidden" name="parentEntryNumber" value={parentEntryNumber} />
                    <input type="hidden" name="qty" value="1" />
                    <input
                      type="hidden"
                      class="__test__"
                      name="serviceGroupNumber"
                      value={selectedCombinedServiceGroupNumber ?? ''}
                    />
                    {#each serviceProductCodes as code}
                      {@const freeGiftData = vasPrice.serviceFreeGiftMap[code] || null}
                      {#if !!freeGiftData}
                        {#each freeGiftData.freeGiftProducts as freeGift}
                          <input type="hidden" name="freeGiftCodesMap[{code}]" value={freeGift.code} />
                          <input type="hidden" name="freeGiftRuleIdMap[{code}]" value={freeGiftData.freeGiftRuleId} />
                        {/each}
                      {/if}
                    {/each}
                    <input type="hidden" name="vasGroup" value={entry.vasGroup} />
                    <input type="hidden" name="showApplyService" value={entry.showApplyService} />
                    <input type="hidden" name="vasEntryShowService" value={entry.showApplyService} />
                    <input
                      type="hidden"
                      name="entryNumber"
                      value={selectedCombinedEntrynumber ?? ''}
                      id="vasEntryNumber"
                      class="js-vasEntryNumber"
                    />
                    <button
                      type="button"
                      id="vas-button-{product.code}{vasPriceIndex}"
                      aria-labelledby="vas-button-{product.code}{vasPriceIndex} vasAddToCartForm{product.code}{vasPriceIndex}"
                      class="c_vas-details-list-button-vas"
                      class:selected={vasPrice.defaultWarranty}
                    >
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </button>
        {/if}
      {/each}
    </div>
    <div
      style="flex-wrap: wrap;"
      class="col-flex-xs-12 col-flex-md-12 c_combined-vas vas-details-wrapper c_vas-details-items js-extraSetup-button-active-remove c-vas-safecaurd"
    >
      {#each entry.vasPrices as vasPrice, vasPriceIndex}
        {@const { combinedVasOptionSelected, combinedVasAddonSelected, selectedServiceVasType } = getVasPriceDetails(
          selectedServices,
          vasPrice
        )}
        {@const serviceProductCodes = getServiceProductCodes(vasPrice, entry)}
        {#if !!vasPrice.additionalAwsProductCode && !!vasPrice.additionalAwsVasGroup}
          {#if vasPrice.vasType?.code === vasPrice.vasType?.code || combinedVasOptionSelected === 'selected'}
            {@const hideShowAddOn =
              (selectedServiceVasType === vasPrice.vasType.code && !vasPrice.noPlanOption) ||
              combinedVasOptionSelected === 'selected'
                ? 'show'
                : 'hide'}
            <div class="c_add-ons-msg {hideShowAddOn}" data-vasType={vasPrice.vasType.code}>
              <div>
                <span class="green-text">
                  {getStr('extra.pdp.service.smartchoice')}
                </span>
                {getStr('extra.pdp.service.dontmissout')}
              </div>
              <span class="addon-subheading">
                {getStr('extra.pdp.service.gobeyondmanufacturer')}
              </span>
            </div>
            <button
              class="c_vas-details-list add-to-cart-addon-service js-addons data-index-{vasPriceIndex} {esstentialclass} {vasPriceIndex} js-vas-details-svelte"
              on:click={jsVasDetailsClickHandler}
              class:no-plan={vasPrice?.noPlanOption}
              class:hide={selectedServiceVasType !== vasPrice.vasType.code}
              class:selected={vasPrice.defaultWarranty || combinedVasAddonSelected === 'selected'}
              data-item-add={combinedVasAddonSelected === 'selected'}
              data-type={entry.serviceTypeLabelEn}
              data-vasType={vasPrice.vasType.code}
              data-source="Cart Popup"
              data-plan={vasPrice.vasType.labelEn}
              data-noplanenabled={entry.noPlanIncluded}
              data-serviceid={vasPriceIndex + 1}
              data-addon="Accidental warranty"
              data-price="{vasPrice?.servicePrice?.formattedValue} {currency}"
              data-productcode={product.code}
              data-id={vasPriceIndex}
              data-entryNumber="extra-vas-{parentEntryNumber}"
            >
              <div class="col-md-12">
                {#if primeEnabled}
                  <div class="c_vas-details-jood-container">
                    {#if membershipType !== NOPRIME}
                      {#if membershipType === BASICPRIME && vasPrice?.vipPrimeDiscountPrice?.value > 0}
                        {incrementServicePrimeCount()}
                      {/if}
                      {#if membershipType === VIPPRIME && vasPrice?.vipPrimeDiscountPrice?.value > 0}
                        <AtcJoodVasPrimeDetails
                          joodType={VIP}
                          vasLabel={addonLabel}
                          vasName={addonName}
                          vasPrice={vasPrice?.servicePrice?.formattedValue}
                          isNoPlan={vasPrice?.noPlanOption}
                        />
                      {:else if membershipType === BASICPRIME && vasPrice?.basicPrimeDiscountPrice?.value > 0}
                        <AtcJoodVasPrimeDetails
                          joodType={BASIC}
                          vasLabel={addonLabel}
                          vasName={addonName}
                          vasPrice={vasPrice?.servicePrice?.formattedValue}
                          isNoPlan={vasPrice?.noPlanOption}
                        />
                      {:else}
                        <AtcJoodVasPrimeDetails
                          joodType={BASIC}
                          vasLabel={addonLabel}
                          vasName={addonName}
                          vasPrice={vasPrice?.servicePrice?.formattedValue}
                          isNoPlan={vasPrice?.noPlanOption}
                        />
                      {/if}
                    {:else}
                      {#if vasPrice?.vipPrimeDiscountPrice?.value > 0}
                        {incrementServicePrimeCount()}
                      {/if}
                      <section>
                        <div class="c_vas-details-list-year c-vas-safecaurd">
                          {#if vasPrice.percentageDiscount !== null && vasPrice.percentageDiscount.value > 0 && vasPrice.percentageDiscount.value < 100}
                            <span class="c_product-details-title-reduction">
                              {#if lang === 'en'}
                                {vasPrice.percentageDiscount.value}%&nbsp;<span
                                  >{getStr('product.pourcentageDiscount.off')}</span
                                >
                              {:else}
                                %{vasPrice.percentageDiscount.value}&nbsp;<span
                                  >{getStr('product.pourcentageDiscount.off')}</span
                                >
                              {/if}
                            </span>
                          {/if}
                          {getStr('extra.pdp.service.addon')}
                        </div>
                        <div class="vas-name" class:hide={vasPrice.noPlanOption}>
                          <span>{getStr('extra.pdp.service.accidental.warranty.text')} ({vasPrice.vasType.name})</span>
                        </div>
                      </section>
                      {#if vasPrice?.discountedPrice !== null}
                        <div class="c_product-price-prices" class:hide={vasPrice.noPlanOption}>
                          <div class="c_product-price-was-is">
                            <span class="c_product-price-previous">{vasPrice.servicePrice.value}</span>
                          </div>
                          <div class="c_product-price-current">
                            <AtcFormatPrice
                              priceData={vasPrice.discountedPrice}
                              displayFreeForZero={true}
                              addCurrency={true}
                            />
                          </div>
                        </div>
                      {:else}
                        <div class="c_vas-details-list-price" class:hide={vasPrice.noPlanOption}>
                          <AtcFormatPrice
                            priceData={vasPrice.servicePrice}
                            displayFreeForZero={true}
                            addCurrency={true}
                          />
                        </div>
                      {/if}
                    {/if}
                  </div>
                {:else}
                  <section>
                    <div class="c_vas-details-list-year c-vas-safecaurd">
                      {#if vasPrice.percentageDiscount !== null && vasPrice.percentageDiscount.value > 0 && vasPrice.percentageDiscount.value < 100}
                        <span class="c_product-details-title-reduction">
                          {#if lang === 'en'}
                            {vasPrice.percentageDiscount.value}%&nbsp;<span
                              >{getStr('product.pourcentageDiscount.off')}</span
                            >
                          {:else}
                            %{vasPrice.percentageDiscount.value}&nbsp;<span
                              >{getStr('product.pourcentageDiscount.off')}</span
                            >
                          {/if}
                        </span>
                      {/if}
                      {vasPrice.vasType.label}
                    </div>
                    <div class="vas-name" class:hide={vasPrice.noPlanOption}>
                      <span>{vasPrice.vasType.name}</span>
                    </div>
                  </section>
                  {#if vasPrice.discountedPrice !== null}
                    <div class="c_product-price-prices" class:hide={vasPrice.noPlanOption}>
                      <div class="c_product-price-was-is">
                        <span class="c_product-price-previous">{vasPrice.servicePrice.value}</span>
                      </div>
                      <div class="c_product-price-current">
                        <AtcFormatPrice
                          priceData={vasPrice.discountedPrice}
                          displayFreeForZero={true}
                          addCurrency={true}
                        />
                      </div>
                    </div>
                  {:else}
                    <div class="c_vas-details-list-price" class:hide={vasPrice.noPlanOption}>
                      <AtcFormatPrice priceData={vasPrice.servicePrice} displayFreeForZero={true} addCurrency={true} />
                    </div>
                  {/if}
                {/if}

                {#each serviceProductCodes as code}
                  {@const freeGiftData = vasPrice.serviceFreeGiftMap[code]}
                  {#if !!freeGiftData}
                    {@const sourceQty = freeGiftData.freeGiftQtuantities['sourceQty']}
                    {@const targetQty = freeGiftData.freeGiftQtuantities['targetQty']}
                    <div
                      class="c_gift-items js-freegiftexist"
                      class:js-freegiff-set-fixed={sourceQty === targetQty}
                      class:c_gift-items-fixed={sourceQty === targetQty}
                    >
                      <div class="c_gift-items-title">
                        {#if sourceQty < targetQty}
                          <span class="c_gift-items-title--color">
                            {getStr('product.promotion.freegifts.display.lower.txt', [sourceQty])}
                          </span>
                        {:else}
                          <span class="c_gift-items-title--color">
                            {getStr('text.fixed.freegift.count.display.txt.vas', [sourceQty])}
                          </span>&nbsp;{getStr('product.promotion.freegifts.item.worth.txt')}&nbsp;
                          <span class="c_gift-items-title--color mobile-font"
                            >{freeGiftData.freeGiftWorth}
                            {@html globalCurrencyTag}</span
                          >
                        {/if}
                      </div>
                    </div>
                  {/if}
                {/each}
              </div>
              <div class="hide">
                <div class="c_vas-details-list-button">
                  <form
                    id="vasAddToCartForm{product.code}{vasPriceIndex}-{loopindex}"
                    action={getContextedUrl('/cart/vas/add')}
                    method="post"
                    class="c_form js-formValidation js-vas-addtocart-form"
                    data-ajax="true"
                    data-submit="vasaddtocart"
                  >
                    <div id="test_vasAddToCartButton_$" style="display:inline">
                      {#if vasPrice.noPlanOption}
                        <input type="hidden" name="vasProductCode" value={entry.noPlanProductCode} />
                        <input type="hidden" name="noPlanOption" value={vasPrice.noPlanOption} />
                      {:else}
                        <input
                          type="hidden"
                          name="vasProductCode"
                          value={vasPrice.productCodes?.length > 0 ? vasPrice.productCodes : entry.serviceProductCode}
                        />
                      {/if}
                      <input type="hidden" name="vasType" value={vasPrice.vasType.code} />
                      <input type="hidden" name="priceType" value={vasPrice.priceType} />
                      <input type="hidden" name="priceTo" value={vasPrice.priceTo} />
                      <input type="hidden" name="productCode" value={product.code} />
                      <input type="hidden" name="additionalAwsProductCode" value={vasPrice.additionalAwsProductCode} />
                      <input type="hidden" name="additionalAwsVasGroup" value={vasPrice.additionalAwsVasGroup} />
                      <input type="hidden" name="combinedVas" value={entry.combinedVas} />
                      <input type="hidden" name="parentEntryNumber" value={parentEntryNumber} />
                      <input type="hidden" name="qty" value="1" />
                      <input
                        type="hidden"
                        name="serviceGroupNumber"
                        value={selectedCombinedAddOnServiceGroupNumber ? selectedCombinedAddOnServiceGroupNumber : ''}
                      />
                      {#each serviceProductCodes as code}
                        {@const freeGiftData = vasPrice.serviceFreeGiftMap[code]}
                        {#if !!freeGiftData}
                          {#each freeGiftData.freeGiftProducts as freeGift}
                            <input type="hidden" name="freeGiftCodesMap[{code}]" value={freeGift.code} />
                            <input type="hidden" name="freeGiftRuleIdMap[{code}]" value={freeGiftData.freeGiftRuleId} />
                          {/each}
                        {/if}
                      {/each}
                      <input type="hidden" name="vasGroup" value={entry.vasGroup} />
                      <input type="hidden" name="showApplyService" value={entry.showApplyService} />
                      <input type="hidden" name="vasEntryShowService" value={entry.showApplyService} />
                      <input
                        type="hidden"
                        name="entryNumber"
                        value={selectedCombinedAddOnEntrynumber ? selectedCombinedAddOnEntrynumber : ''}
                        id="vasEntryNumber"
                        class="js-vasEntryNumber"
                      />
                      <button
                        type="button"
                        id="vas-button-{product.code}{vasPriceIndex}"
                        aria-labelledby="vas-button-{product.code}{vasPriceIndex} vasAddToCartForm{product.code}{vasPriceIndex}"
                        data-vasType={vasPrice.vasType.code}
                        data-serviceProductCode={entry.serviceProductCode}
                        class="c_vas-details-list-button-vas"
                        class:selected={vasPrice.defaultWarranty}
                      >
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </button>
          {/if}
        {/if}
      {/each}
    </div>
  {:else}
    <div
      style="flex-wrap: nowrap;"
      class="{membershipType} js-vas-group-addtocart-{entry.vasGroup} col-flex-xs-12 col-flex-md-12 vas-details-wrapper c_vas-details-items js-extraSetup-button-active-remove c-vas-safecaurd"
    >
      {#each entry.vasPrices as vasPrice, vasPriceIndex}
        {@const serviceProductCodes = getServiceProductCodes(vasPrice, entry)}
        {@const { vasOptionSelected, selectedEntrynumber } = getVasDetails(selectedServices, vasPrice)}
        {@const serviceJoodCardType = getServiceJoodCardType(
          membershipType,
          expiredMembershipType,
          vasPrice,
          isPrimeNoPlan
        )}
        <button
          class="{membershipType}  c_vas-details-list add-to-cart-service data-index-{vasPriceIndex} {esstentialclass} {vasPriceIndex} js-vas-details-svelte {benefitType ===
          'WALLET'
            ? `service-${serviceJoodCardType}`
            : ''}"
          on:click={jsVasDetailsClickHandler}
          class:no-plan={vasPrice?.noPlanOption}
          class:selected={vasPrice.defaultWarranty || vasOptionSelected?.length > 0}
          data-item-add={vasOptionSelected === 'selected'}
          data-type={servicesBlockLabel}
          data-source="Cart Popup"
          data-service="safeguard"
          data-plan={vasPrice.vasType.labelEn}
          data-noplanenabled={entry.noPlanIncluded}
          data-vasType={vasPrice.vasType.code}
          data-serviceid={vasPriceIndex + 1}
          data-addon="no addon"
          data-price="{vasPrice?.servicePrice?.formattedValue} {currency}"
          data-productcode={product.code}
          data-id={vasPriceIndex}
          data-entryNumber="extra-vas-{parentEntryNumber}"
        >
          <div>
            {#if primeEnabled}
              <div class="c_vas-details-jood-container">
                {#if membershipType !== NOPRIME}
                  {#if membershipType === BASICPRIME && vasPrice?.vipPrimeDiscountPrice?.value > 0}
                    {incrementServicePrimeCount()}
                  {/if}

                  {#if membershipType === VIPPRIME && vasPrice?.vipPrimeDiscountPrice?.value > 0}
                    <AtcJoodVasPrimeDetails
                      joodType={VIP}
                      vasLabel={vasPrice.vasType.label}
                      oldVasPrice={vasPrice?.servicePrice?.formattedValue}
                      vasPrice={vasPrice?.vipPrimeDiscountPrice?.formattedValue}
                      vasName={vasPrice?.vasType?.name}
                      isNoPlan={vasPrice?.noPlanOption}
                    />

                    {#if benefitType === 'WALLET' && !joodCapLimitReached}
                      <ProductTileJoodWalletCreditAmount
                        creditPoints={vasPrice?.vipPrimeDiscountPrice?.formattedValue}
                        variant="pdp-services"
                        priceType={VIPPRIME}
                        isTacticalFlag={false}
                      />
                    {/if}
                  {:else if membershipType === BASICPRIME && vasPrice?.basicPrimeDiscountPrice?.value > 0}
                    <AtcJoodVasPrimeDetails
                      joodType={BASIC}
                      vasLabel={vasPrice.vasType.label}
                      oldVasPrice={vasPrice?.servicePrice?.formattedValue}
                      vasPrice={vasPrice?.basicPrimeDiscountPrice?.formattedValue}
                      vasName={vasPrice?.vasType?.name}
                      isNoPlan={vasPrice?.noPlanOption}
                    />
                    {#if benefitType === 'WALLET' && !joodCapLimitReached}
                      <ProductTileJoodWalletCreditAmount
                        creditPoints={vasPrice?.basicPrimeDiscountPrice?.formattedValue}
                        variant="pdp-services"
                        priceType={BASICPRIME}
                        isTacticalFlag={false}
                      />
                    {/if}
                  {:else if membershipType === SMARTPRIME && vasPrice?.smartPrimeDiscountPrice?.value > 0}
                    <AtcJoodVasPrimeDetails
                      joodType={SMART}
                      vasLabel={vasPrice.vasType.label}
                      oldVasPrice={vasPrice?.servicePrice?.formattedValue}
                      vasPrice={vasPrice?.smartPrimeDiscountPrice?.formattedValue}
                      vasName={vasPrice?.vasType?.name}
                      isNoPlan={vasPrice?.noPlanOption}
                    />
                    {#if benefitType === 'WALLET' && !joodCapLimitReached}
                      <ProductTileJoodWalletCreditAmount
                        creditPoints={vasPrice?.smartPrimeDiscountPrice?.formattedValue}
                        variant="pdp-services"
                        priceType={SMARTPRIME}
                        isTacticalFlag={false}
                      />
                    {/if}
                  {:else}
                    <AtcJoodVasPrimeDetails
                      joodType={BASIC}
                      vasLabel={vasPrice.vasType.label}
                      oldVasPrice={vasPrice?.servicePrice?.formattedValue}
                      vasPrice={vasPrice?.discountedPrice?.formattedValue}
                      vasName={vasPrice?.vasType?.name}
                      isNoPlan={vasPrice?.noPlanOption}
                    />
                  {/if}
                {:else if membershipType === NOPRIME || expiredMembershipType === BASICPRIME || expiredMembershipType === VIPPRIME || expiredMembershipType === SMARTPRIME}
                  {#if vasPrice?.vipPrimeDiscountPrice?.value > 0}
                    {incrementServicePrimeCount()}
                  {/if}
                  <section>
                    <div class="c_vas-details-list-year c-vas-safecaurd">
                      {#if vasPrice.percentageDiscount !== null && vasPrice.percentageDiscount.value > 0 && vasPrice.percentageDiscount.value < 100}
                        <span class="c_product-details-title-reduction">
                          {#if lang === 'en'}
                            {vasPrice.percentageDiscount.value}%&nbsp;<span
                              >{getStr('product.pourcentageDiscount.off')}</span
                            >
                          {:else}
                            %{vasPrice.percentageDiscount.value}&nbsp;<span
                              >{getStr('product.pourcentageDiscount.off')}</span
                            >
                          {/if}
                        </span>
                      {/if}
                      {vasPrice.vasType.label}
                    </div>
                    <div class="vas-name" class:hide={vasPrice.noPlanOption}>
                      <span>{vasPrice.vasType.name}</span>
                    </div>
                  </section>
                  {#if vasPrice.discountedPrice !== null}
                    <div class="c_product-price-prices" class:hide={vasPrice.noPlanOption}>
                      <div class="c_product-price-was-is">
                        <span class="c_product-price-previous">{vasPrice.servicePrice.value}</span>
                      </div>
                      <div class="c_product-price-current">
                        <AtcFormatPrice
                          priceData={vasPrice.discountedPrice}
                          displayFreeForZero={true}
                          addCurrency={true}
                        />
                      </div>
                    </div>
                  {:else}
                    <div class="c_vas-details-list-price" class:hide={vasPrice.noPlanOption}>
                      <AtcFormatPrice priceData={vasPrice.servicePrice} displayFreeForZero={true} addCurrency={true} />
                    </div>
                  {/if}
                  {#if expiredMembershipType === BASICPRIME && vasPrice?.basicPrimeDiscountPrice?.value > 0}
                    {#if benefitType === 'WALLET' && !joodCapLimitReached}
                      <ProductTileJoodWalletCreditAmount
                        creditPoints={vasPrice?.basicPrimeDiscountPrice?.formattedValue}
                        variant="pdp-services"
                        priceType={BASICPRIME}
                        isTacticalFlag={false}
                      />
                    {/if}
                  {:else if expiredMembershipType === SMARTPRIME && vasPrice?.smartPrimeDiscountPrice?.value > 0}
                    {#if benefitType === 'WALLET' && !joodCapLimitReached}
                      <ProductTileJoodWalletCreditAmount
                        creditPoints={vasPrice?.smartPrimeDiscountPrice?.formattedValue}
                        variant="pdp-services"
                        priceType={SMARTPRIME}
                        isTacticalFlag={false}
                      />
                    {/if}
                  {:else if vasPrice?.vipPrimeDiscountPrice?.value > 0}
                    {#if benefitType === 'WALLET' && !joodCapLimitReached && membershipType !== NOPRIME}
                      <ProductTileJoodWalletCreditAmount
                        creditPoints={vasPrice?.vipPrimeDiscountPrice?.formattedValue}
                        variant="pdp-services"
                        priceType={VIPPRIME}
                        isTacticalFlag={false}
                      />
                    {/if}
                  {/if}
                {/if}
              </div>
            {:else}
              <section>
                <div class="c_vas-details-list-year c-vas-safecaurd">
                  {#if vasPrice.percentageDiscount !== null && vasPrice.percentageDiscount.value > 0 && vasPrice.percentageDiscount.value < 100}
                    <span class="c_product-details-title-reduction">
                      {#if lang === 'en'}
                        {vasPrice.percentageDiscount.value}%&nbsp;<span
                          >{getStr('product.pourcentageDiscount.off')}</span
                        >
                      {:else}
                        %{vasPrice.percentageDiscount.value}&nbsp;<span
                          >{getStr('product.pourcentageDiscount.off')}</span
                        >
                      {/if}
                    </span>
                  {/if}
                  {vasPrice.vasType.label}
                </div>
                <div class="vas-name" class:hide={vasPrice.noPlanOption}>
                  <span>{vasPrice.vasType.name}</span>
                </div>
              </section>
              {#if vasPrice.discountedPrice !== null}
                <div class="c_product-price-prices" class:hide={vasPrice.noPlanOption}>
                  <div class="c_product-price-was-is">
                    <span class="c_product-price-previous">{vasPrice.servicePrice.value} </span>
                  </div>
                  <div class="c_product-price-current">
                    <AtcFormatPrice priceData={vasPrice.discountedPrice} displayFreeForZero={true} addCurrency={true} />
                  </div>
                </div>
              {:else}
                <div class="c_vas-details-list-price" class:hide={vasPrice.noPlanOption}>
                  <AtcFormatPrice priceData={vasPrice.servicePrice} displayFreeForZero={true} addCurrency={true} />
                </div>
              {/if}
            {/if}

            {#each serviceProductCodes as code}
              {@const freeGiftData = vasPrice.serviceFreeGiftMap[code]}
              {#if !!freeGiftData}
                {@const sourceQty = freeGiftData.freeGiftQtuantities['sourceQty']}
                {@const targetQty = freeGiftData.freeGiftQtuantities['targetQty']}
                <div
                  class="c_gift-items js-freegiftexist"
                  class:js-freegiff-set-fixed={sourceQty === targetQty}
                  class:c_gift-items-fixed={sourceQty === targetQty}
                >
                  <div class="c_gift-items-title">
                    {#if sourceQty < targetQty}
                      <span class="c_gift-items-title--color">
                        {getStr('product.promotion.freegifts.display.lower.txt', [sourceQty])}</span
                      >
                    {:else}
                      <span class="c_gift-items-title--color">
                        {getStr('text.fixed.freegift.count.display.txt.vas', [sourceQty])}
                      </span>&nbsp;{getStr('product.promotion.freegifts.item.worth.txt')}&nbsp;
                      <span class="c_gift-items-title--color mobile-font"
                        >{freeGiftData.freeGiftWorth}
                        {@html globalCurrencyTag}</span
                      >
                    {/if}
                  </div>
                </div>
              {/if}
            {/each}
          </div>
          <div class="hide">
            <div class="c_vas-details-list-button">
              <form
                id="vasAddToCartForm{product.code}{vasPriceIndex}-{loopindex}"
                action={getContextedUrl('/cart/vas/add')}
                method="post"
                class="c_form js-formValidation js-vas-addtocart-form"
                data-ajax="true"
                data-submit="vasaddtocart"
              >
                <div id="test_vasAddToCartButton_$" style="display:inline">
                  {#if vasPrice.noPlanOption}
                    <input type="hidden" name="vasProductCode" value={entry.noPlanProductCode} />
                    <input type="hidden" name="noPlanOption" value={vasPrice.noPlanOption} />
                  {:else}
                    <input
                      type="hidden"
                      name="vasProductCode"
                      value={vasPrice.productCodes?.length > 0 ? vasPrice.productCodes : entry.serviceProductCode}
                    />
                  {/if}
                  <input type="hidden" name="vasType" value={vasPrice.vasType.code} />
                  <input type="hidden" name="priceType" value={vasPrice.priceType} />
                  <input type="hidden" name="priceTo" value={vasPrice.priceTo} />
                  <input type="hidden" name="productCode" value={product.code} />
                  <input type="hidden" name="additionalAwsProductCode" value={vasPrice.additionalAwsProductCode} />
                  <input type="hidden" name="additionalAwsVasGroup" value={vasPrice.additionalAwsVasGroup} />
                  <input type="hidden" name="combinedVas" value={entry.combinedVas} />
                  <input type="hidden" name="parentEntryNumber" value={parentEntryNumber} />
                  <input type="hidden" name="qty" value="1" />
                  <input type="hidden" name="serviceGroupNumber" value="" />
                  {#each serviceProductCodes as code}
                    {@const freeGiftData = vasPrice.serviceFreeGiftMap[code]}
                    {#if !!freeGiftData}
                      {#each freeGiftData.freeGiftProducts as freeGift}
                        <input type="hidden" name="freeGiftCodesMap[{code}]" value={freeGift.code} />
                        <input type="hidden" name="freeGiftRuleIdMap[{code}]" value={freeGiftData.freeGiftRuleId} />
                      {/each}
                    {/if}
                  {/each}
                  <input type="hidden" name="vasGroup" value={entry.vasGroup} />
                  <input type="hidden" name="showApplyService" value={entry.showApplyService} />
                  <input type="hidden" name="vasEntryShowService" value={entry.showApplyService} />
                  <input
                    type="hidden"
                    name="entryNumber"
                    value={typeof selectedEntrynumber === 'number' ? selectedEntrynumber : ''}
                    id="vasEntryNumber"
                    class="js-vasEntryNumber"
                  />
                  <button
                    type="button"
                    id="vas-button-{product.code}{vasPriceIndex}"
                    aria-labelledby="vas-button-{product.code}{vasPriceIndex} vasAddToCartForm{product.code}{vasPriceIndex}"
                    class="c_vas-details-list-button-vas"
                    class:selected={vasPrice.defaultWarranty}
                  >
                  </button>
                </div>
              </form>
            </div>
          </div>
        </button>
      {/each}
    </div>
  {/if}
  <!-- commenting out as per Jood + RMN requirement -->
  {#if joodExpiredFlag && benefitType === 'WALLET'}
    <div class="my-3">
      <JoodExpire />
    </div>
  {/if}
  {#if primeEnabled && benefitType === 'DISCOUNT' && _servicePrimeCount > 0 && joodExpiredFlag}
    <div class="c_vas-details-jood-reveal-container">
      <AtcJoodVasService
        vasEntry={entry}
        linkType=""
        joodType={joodExpiredFlag}
        isRevealState={true}
        typeClass="jood-cart-guest"
      />
    </div>
  {/if}
</div>
<div class="row-flex">
  <div class="col-flex-xs-6 col-flex-md-3"></div>
  <div class="col-flex-xs-12 col-flex-md-9 simple-flex">
    <div class="js-apply-service-option-{product.code}-extra-vas-{parentEntryNumber}">
      <div class="row-flex c_apply-service-title">
        {product.attributeLabels.extraContentApplyService}
      </div>
      <div class="row-flex c_apply-service">
        <div
          data-applyservice="false"
          data-entrynumber={parentEntryNumber}
          data-vasGroup={entry.vasGroup}
          class="col-flex-xs-6 col-flex-sm-6 col-flex-md-6 c_apply-service-content js-apply-service-content selected"
        >
          <span class="selected-icon"></span>
          <img alt="ExtraSetup" src={extra_service_store_device} />
          <div class="c_apply-service-info">
            {product.attributeLabels.extraTextNotApplyService}
          </div>
        </div>
        <div class="c_apply-service-or-divider">or</div>
        <div
          data-applyservice="true"
          data-entrynumber={parentEntryNumber}
          data-vasGroup={entry.vasGroup}
          class="col-flex-xs-6 col-flex-sm-6 col-flex-md-6 c_apply-service-content js-apply-service-content"
        >
          <span class="selected-icon"></span>
          <img alt="ExtraSetup" src={extra_service_unpack_device} />
          <div class="c_apply-service-info">
            {product.attributeLabels.extraTextApplyService}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row-flex c_no-service-div" class:hide={noPlanVasOptionSelected != true}>
  <div class="col-flex-xs-12 col-flex-md-12 c_no-service-text">
    <span class="orange-text">{getStr('extra.pdp.service.areyousure')}</span>
    <span>{getStr('extra.pdp.service.yourdevice')}</span>
  </div>
</div>
